import { render, staticRenderFns } from "./TablaBascula.vue?vue&type=template&id=4eb3e20e"
import script from "./TablaBascula.vue?vue&type=script&lang=ts"
export * from "./TablaBascula.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports